import { Box, Flex, Text, HStack, useMediaQuery, Button, useToast, VStack, Image } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import TextField from 'components/TextField';
import { Formik, Form } from 'formik';
import validaCPF from '../../Utils/Functions/validaCPF';
import * as Yup from 'yup';
import useModelCartao from './useModelCartao';
import { useNavigate } from 'react-router-dom';
import Pagamento from '../../../images/Pagamento.svg';

function CadastrarCartao() {
  const { setUser, setPage, user } = useContext(AccountContext);
  const state = useLocation();
  const { themeApp } = state?.state;
  const voltar = state?.state?.voltar;
  let defaultCard;
  let defaulData = { cvv: '', name: '', cardNumber: '' };
  const [data, setData] = useState(defaulData);
  const toast = useToast();
  const navigate = useNavigate();
  const cartaoState = state?.state?.card;
  const editar = state?.state?.editar;
  const { cadastrarCartao, loading, error, cartaoCadastrado, retornoCartao, errorMessa, error_message } = useModelCartao({
    dados: data,
    client_id: user?.id_cliente_deovita,
    editar,
    cartaoState,
  });
  console.log('error_message no CadastrarCartao', error_message)

  useEffect(() => {
    setPage('Adicionar Cartão');
  }, [setPage]);

  const HandleChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  const [lg] = useMediaQuery('(min-width: 425px)');

  useEffect(() => {
    if (!error && cartaoCadastrado) {
      setTimeout(() => {
        if (voltar) {
          navigate(-1);
          return;
        }
        navigate('/perfil/menu-pagamentos');
      }, 2000);
      return;
    }

    if (error) {
      toast({
        title: 'Importante',
        description: error_message || 'Não foi possível concluir a solicitação. Tente novamente mais tarde.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'bottom',
        colorScheme: 'red',
        containerStyle: {
          paddingTop: '50px',
        },
      });
    }
  }, [error, cartaoCadastrado]);

  return (
    <>
      <ChildHeader />
      <Box>
        {!error && cartaoCadastrado ? (
          <>
            <Box display="flex" justifyContent="center" alignItems="center" w="100%" minHeight="50vh" flexDirection="column">
              <VStack w={'100%'} justifyContent="center" alignItems="center">
                <Box bg={'#F3F3F3'} w={'80%'} align={'center'} p={4} borderRadius={'0.8em'}>
                  <Image src={Pagamento} alt="Pagamento" />
                  <Text color={'#585858'} fontWeight={'bold'} fontSize={'20px'} mt={2}>
                    Seu <span style={{ color: '#5AB2AE' }}>cartão</span> foi <br /> cadastrado com <span style={{ color: '#5AB2AE' }}>sucesso</span>.
                  </Text>
                </Box>
              </VStack>
            </Box>
          </>
        ) : (
          <>
            <Flex m={8} mb={2} justify="center">
              <Box bg={'#5AB2AE'} borderRadius="1em" p={6} boxShadow="xl" w="100%" maxW="400px" color="white">
                <Flex justify="space-between" align="center" mb={6}>
                  <Box bg="white" borderRadius="1em" boxSize="60px" />
                </Flex>
                <Box mt="8">
                  <Text fontSize="lg" fontWeight="bold">
                    NOME DO TITULAR
                  </Text>
                  <Text fontSize="sm" letterSpacing="wide">
                    1234 XXXX XXXX 5678
                  </Text>
                </Box>
              </Box>
            </Flex>
            <Formik
              initialValues={{ cpf: '' }}
              validateOnChange={false}
              validateOnBlur={false}
              validationSchema={Yup.object({
                cpf: Yup.string()
                  .required('Cpf Obrigatório!')
                  .trim()
                  .test('valida_cpf', 'Cpf inválido', (cpf) => validaCPF(cpf)),
              })}
              onSubmit={(values, actions) => {
                cadastrarCartao(values);
              }}
            >
              <Flex direction="column" m={8} mb={4} as={Form} gap={4}>
                <Text color="#585858" fontWeight="bold" fontSize="lg">
                  Dados do cartão de crédito
                </Text>

                <TextField
                  label={'Número do Cartão'}
                  name="cardNumber"
                  type="tel"
                  placeholder="xxxx xxxx xxxx xxxx"
                  mask="9999 9999 9999 9999"
                  maskChar={null}
                  onBlur={HandleChange}
                  required
                />
                <HStack gridTemplateColumns={lg ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'} gap={4}>
                  <TextField
                    label={'Data de validade'}
                    name="expirationDate"
                    placeholder="xx/xx"
                    type="tel"
                    mask="99/99"
                    maskChar={null}
                    onBlur={HandleChange}
                    required
                  />
                  <TextField label={'CVV'} name="cvv" type="tel" placeholder="xxx" onBlur={HandleChange} required />
                </HStack>
                <TextField
                  label={'CPF'}
                  name="cpf"
                  type="tel"
                  placeholder="xxx.xxx.xxx-xx"
                  mask="999.999.999-99"
                  maskChar={null}
                  onBlur={HandleChange}
                  required
                />
                <TextField
                  label={'Titular do cartão'}
                  name="card_holder_name"
                  type="text"
                  placeholder="Digite o nome do titular"
                  onBlur={HandleChange}
                  required
                />
                <Text color={'red'} fontSize={'15px'}>
                  {retornoCartao}
                </Text>
                {error && (
                  <>
                    <Text color={'red'} fontSize={'15px'}>
                      {error_message || 'Não foi possível concluir a solicitação. Tente novamente mais tarde.'}
                    </Text>
                  </>
                )}

                <Button bg={'#5AB2AE'} w="100%" type="submit" color={'white'} isDisabled={loading} loading={loading} >
                  Adicionar cartão
                </Button>
                <Text color={'red'}> {errorMessa}</Text>
              </Flex>
            </Formik>
          </>
        )}
      </Box>
    </>
  );
}

export default CadastrarCartao;
